export enum SavedSearchTypes {
  GET_SAVED_SEARCHES = '@@dashboard/GET_SAVED_SEARCHES',
  GET_SAVED_SEARCHES_SUCCESS = '@@dashboard/GET_SAVED_SEARCHES_SUCCESS',
  GET_SAVED_SEARCHES_FAIL = '@@dashboard/GET_SAVED_SEARCHES_FAIL',

  GET_FILTER_DATA = '@@dashboard/GET_FILTER_DATA_SAVED_SEARCHES',
  GET_FILTER_DATA_SUCCESS = '@@dashboard/GET_FILTER_DATA_SAVED_SEARCHES_SUCCESS',
  GET_FILTER_DATA_FAIL = '@@dashboard/GET_FILTER_DATA_SAVED_SEARCHES_Fail',

  SAVE_SEARCH = '@@dashboard/SAVE_SEARCH',
  SAVE_SEARCH_SUCCESS = '@@dashboard/SAVE_SEARCH_SUCCESS',
  SAVE_SEARCH_FAIL = '@@dashboard/SAVE_SEARCH_FAIL',

  DELETE_SEARCHES = '@@dashboard/DELETE_SEARCHES',
  DELETE_SEARCHES_SUCCESS = '@@dashboard/DELETE_SEARCHES_SUCCESS',
  DELETE_SEARCHES_FAIL = '@@dashboard/DELETE_SEARCHES_FAIL',
}
